import { freeUserUpgradeStep } from '../utils';

export const myTeamNpoTour = {
  tourKey: 'my_team_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.my-team-business-free.welcome.title',
      content: 'tours.my-team-business-free.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="my-team-invite"]',
      title: 'tours.my-team-business-free.invite.title',
      content: 'tours.my-team-npo.invite.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="my-team-invite-link"]',
      title: 'tours.my-team-business-free.invite-link.title',
      content: 'tours.my-team-npo.invite-link.content',
      placement: 'bottom',
    },
    freeUserUpgradeStep,
  ],
};
